import styled from "styled-components";
import {Col as AntdCol, Layout} from "antd";
import {Button as StyledButton, Button2} from "../../styles/buttons";

export const Container = styled(Layout)`
  padding: 0.5rem 1rem;
  gap: 1rem;
  position: relative;

  @media (min-width: 768px) {
    padding: 1rem 2rem;
  }
`;

export const Button = styled(Button2)`
  width: unset;
  margin-top: 0;
  margin-left: 10px;
  align-self: flex-end;
  border-radius: 20px;
`;

export const Form = styled.form``;

export const Label = styled.label`
  font-size: 18px;
  font-weight: bold;
`;

export const Col = styled(AntdCol)`
  width: 12.4rem;
  margin-bottom: 0.8rem;

  input {
    width: 100%;
    height: 2rem;
    padding: 0 11px                                                                           ;
    color: rgba(0, 0, 0, 0.85);
    font-size: 14px;
    background-color: #fff;
    background-image: none;
    border: 1px solid #d9d9d9;
    border-radius: 2px;
    transition: all 0.3s;

    &:focus, &:hover {
      border-color: ${(props) => props.theme.colors.cyanDark};
      outline-color: transparent;
    }

    &:focus {
      box-shadow: 0 0 0 2px rgb(22 158 173 / 20%);
    }
  }

  @media (max-width: 768px) {
    min-width: 0em;
  }
`;

export const ValueCard = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;

  div {
    text-align: center;
    margin-right: 20px;
    margin-bottom: 8px;
    border-radius: 8px;
    background-color: white;
    padding: 10px;
    height: 90px;
    width: 160px;
    border: 1px solid rgba(92, 92, 92, 0.22);
    box-shadow: 1px 2px 9px rgba(92, 92, 92, 0.55);
  }

  @media (max-width: 940px) {
    flex-wrap: wrap;
    height: auto;
    align-content: space-around;
    justify-content: center;

    div {
      margin-top: 0 !important;
      margin-bottom: 0 !important;
      margin-right: 4px;
    }
  }
`;

export const TableContainer = styled.div`
  @media (max-width: 768px) {
    display: none;
    }

  .ant-pagination-item,
  .ant-pagination-jump-next,
  .ant-pagination-jump-prev {
    display: none;
  }

  display: flex;
  justify-content: center;
`;

// export const DownloadButton = styled(Button2)`
//   width: auto;
//   padding: 8px 24px;
//   margin-bottom: 16px;
//   border-radius: 8px;
//   font-weight: 600;
//   font-size: 14px;
//   background-color: ${(props) => props.theme.colors.cyanDark};
//   color: white;
//   border: none;
//
//   &:hover {
//     opacity: 0.9;
//     transform: translateY(-1px);
//     box-shadow: 0 4px 12px rgba(22, 158, 173, 0.3);
//   }
//
//   &:active {
//     transform: translateY(0);
//   }
// `;

export const ToggleButton = styled.button`
  padding: 8px 20px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 14px;
  background-color: white;
  color: ${(props) => props.theme.colors.cyanDark};
  border: 2px solid ${(props) => props.theme.colors.cyanDark};
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background-color: ${(props) => props.theme.colors.cyanDark};
    color: white;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(22, 158, 173, 0.3);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const TableHeader = styled.div`
  min-width: 62%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding: 16px 20px;
  background: linear-gradient(135deg, #f5f5f5 0%, #ffffff 100%);
  border-radius: 12px;
  border: 1px solid #e0e0e0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 16px;
  }
`;

export const FeeInfoText = styled.p`
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: #333;
  display: flex;
  align-items: center;
  gap: 8px;

  span {
    color: ${(props) => props.theme.colors.cyanDark};
    font-size: 16px;
    font-weight: 700;
  }
`;

export const ToggleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  background-color: #f0f0f0;
  padding: 4px;
  border-radius: 24px;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.1);
`;

export const ToggleOption = styled.button<{ isActive: boolean }>`
  padding: 8px 12px;
  border: none;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;

  background-color: ${props => props.isActive ? props.theme.colors.cyanDark : 'transparent'};
  color: ${props => props.isActive ? 'white' : '#666'};
  box-shadow: ${props => props.isActive ? '0 2px 8px rgba(22, 158, 173, 0.3)' : 'none'};

  &:hover {
    background-color: ${props => props.isActive ? props.theme.colors.cyanDark : '#e0e0e0'};
    color: ${props => props.isActive ? 'white' : '#333'};
  }

  &:active {
    transform: scale(0.98);
  }
`;

export const ChannelLabel = styled.span`
  font-size: 13px;
  font-weight: 500;
  color: #666;
  margin-right: 2px;
  margin-left: 4px;
`;

export const DownloadButton = styled(Button2)`
  width: auto;
  padding: 18px 30px;
  margin-bottom: 16px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 14px;
  background-color: ${(props) => props.theme.colors.cyanDark};
  color: white;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  &:hover {
    opacity: 0.9;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(22, 158, 173, 0.3);
  }

  &:active {
    transform: translateY(0);
  }
`;
